import { createContext, useState } from "react";

export const GuestSignUpModalContext = createContext({
  openGuestSignUpModal: false,
  setOpenGuestSignUpModal: () => false,
});

export const GuestSignUpModalProvider = ({ children }) => {
  const [openGuestSignUpModal, setOpenGuestSignUpModal] = useState(false);
  const value = { openGuestSignUpModal, setOpenGuestSignUpModal };
  return (
    <GuestSignUpModalContext.Provider value={value}>
      {children}
    </GuestSignUpModalContext.Provider>
  );
};
